import { OrderGetFinancesRequest } from '@trukt/tms-api/OrderFinanceService';
import { createKey } from '../../createKey';

const keyHandler = createKey('orderFinances');

export const OrderFinancesServiceKeys = {
  key: keyHandler.key,
  getById: keyHandler.createMethod<OrderGetFinancesRequest>(),
};
